import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, Avatar } from '@mui/material';
import useResponsive from '../../../hooks/useResponsive';
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
import navConfig, { icon } from './config';
import { useAuthContext } from '../../../auth/useAuthContext';
import { isExpiredSubscription } from '../../../utils/formatTime';
import agencyNavConfig from './agencyConfig';
import Button from 'src/theme/overrides/Button';
import dayjs from 'dayjs';
import { StyledNavItemIcon } from 'src/components/nav-section/styles';

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

export default function Nav({ openNav, onCloseNav, onboardingLocked = false }) {
  const { pathname } = useLocation();
  const { user } = useAuthContext();
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const isExpiredSub =
    user.subscription.subscriptionId &&
    isExpiredSubscription(user.subscription.dateExpiry);
  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box sx={{ px: '40px', py: 3, display: 'inline-flex' }}>
        <Logo width="160px" />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={user.avatar} />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {user.firstName} {user.lastName}
              </Typography>

              {window.location.hostname.includes("agency.flowbookings.io") ? <Typography></Typography> : <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {user.subscription.plan}{' '}
                {isExpiredSub ? (
                  <Typography sx={{ color: 'red' }}>(Expired)</Typography>
                ) : null}
              </Typography>}
            </Box>
          </StyledAccount>
        </Link>
      </Box>
      <NavSection
        // data={window.location.hostname.includes("agency.flowbookings.io") ? agencyNavConfig : navConfig}
        data={window.location.hostname.includes("agency.flowbookings.io") ? agencyNavConfig : navConfig}
        userId={user._id}
        user={user}
        isExpiredSub={window.location.hostname.includes("agency.flowbookings.io") ? false : isExpiredSubscription(user.subscription.dateExpiry)}
        onboardingLocked={onboardingLocked}
      />
      {/* {user.createdAt && (dayjs("2025-02-12").diff(dayjs(user.createdAt), 'day') > 7) && ( */}
      {dayjs(user.createdAt).isBefore(dayjs("2025-02-11")) && (
        <a href="https://app-old-version.flowbookings.io" style={{ textDecoration: 'none' }}>
        <div
          style={{
            display: 'flex',
            paddingLeft: 20,
            alignItems: 'center',
            padding: '10px',
            cursor: 'pointer',
            background: 'rgba(145, 158, 171, 0.08)',
            color: '#626262',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontSize: '12px',
            marginTop: '25px',
            textDecoration: 'none',
            paddingLeft: 20
          }}
        >
          <StyledNavItemIcon sx={{ width: 14, height: 14 }}>
             {icon('ic_pop')}
          </StyledNavItemIcon> 
          Old Version
        </div>
        </a>
      )}
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
